import React, { Component } from 'react'
import placeholderLogo from '../assets/companies/placeholder.png'
import ReactImageFallback from 'react-image-fallback'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import ReactGA from 'react-ga'

import { sendEvent } from '../events'

const reportEvent = (user, company, title, event) => {
  sendEvent('Press', user, company, title)
  ReactGA.event({
    category: 'Position external redirect',
    action: company,
    label: title + '|' + event.target.href,
    transport: 'beacon'
  })
}

const TopLink = styled.a`
  color: #00B4E9;
  font-size: .7rem;
`
const PositionLink = styled.a`
  color: white;
  background-color: #83D4DB;
  border: none;
  border-radius: 0;
`
const MoreButton = styled.button`
  && {
    color: #00B4E9;
    vertical-align: baseline;
    padding: 0;
  }
`
const Wrapper = styled.div.attrs({className: 'card'})`
  && {
    color: #6c757d;
    margin-bottom: 40px;
    box-shadow: ${({expanded}) => expanded ? '10px 10px 0 0 rgba(0,0,0,0.1)' : '0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)'};
      @media (max-width: 767.98px) {
        margin-bottom: 30px;
        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
      }
  }
`

const Location = styled.h6`
  font-size: .8rem;
`
class Card extends Component {
  static defaultProps = {
    length: 210,
    logo: placeholderLogo
  }

  static propTypes = {
    length: PropTypes.number,
    link: PropTypes.string,
    company: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    logo: PropTypes.string,
    user: PropTypes.object
  }

  state = { expanded: false }

  toggle = () => {
    this.setState({ expanded: !this.state.expanded })
    sendEvent('Expand', this.props.user, this.props.company, this.props.title)
  }

  render() {
    const { expanded } = this.state
    const { link, company, title, description: dataDescription, logo, length, skill, location, user } = this.props
    let description = dataDescription || skill
    return (
      <Wrapper expanded={expanded}>
        <div className="card-header bg-white border-bottom-0">
          <TopLink onClick={(e) => reportEvent(user, company, title, e)} href={link} target="_blank">[ {company} ]</TopLink>
          <ReactImageFallback src={logo} fallbackImage={placeholderLogo} alt={company} className="float-right" height="30"/>
        </div>
        <div className="card-body pt-0">
          <h5 className="card-title">{title}</h5><Location>{location}</Location>
          <div className="card-text">
            {expanded || description.length <= length ? description : description.slice(0, description.indexOf(' ', length)).replace(/[\W]+$/, '')}
            {expanded ? (
              <div className="row pt-2">
                <div className="col">
                  <PositionLink onClick={(e) => reportEvent(user, company, title, e)} href={link} target="_blank" rel="noopener noreferrer" className="btn btn-outline-info">Position Page</PositionLink>
                </div>
                <div className="col text-right">
                  <button type="button" className="btn btn-link btn-sm text-muted"  aria-label="Close" onClick={this.toggle}>
                    <span aria-hidden="true">&times;</span> Less
                  </button>
                </div>
              </div>
            ) : <MoreButton type="button" className="btn btn-link" onClick={this.toggle}>{description.length > length ? '..' : ''}&nbsp;More</MoreButton>}
          </div>
        </div>
      </Wrapper>
    )
  }
}

export default Card



// WEBPACK FOOTER //
// ./src/components/card.js